module.exports = __webpack_public_path__ + "static/img/bgs1.542163e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/bgs1.jpg
// module id = fr+8
// module chunks = 1